// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2VxJ2","footer":"ModalInfo_footer__MkcNS"};